import { Chip, ChipProps } from '@mui/material';
import { forwardRef } from 'react';
import { COLORS } from 'services/constants/colors';

interface IEasChipProps extends Omit<ChipProps, 'color' | 'size' | 'onClick' | 'label'> {
	label: string;
	color?: string;
	bgcolor?: string;
	size?: 'small' | 'medium';
	bold?: boolean;
	onClick?: () => void;
}

export const EasChip = forwardRef<HTMLDivElement, IEasChipProps>(
	(
		{
			label,
			color = COLORS.font_main,
			bgcolor = COLORS.SECONDARY,
			size = 'small',
			bold = false,
			onClick,
			...rest
		},
		ref,
	) => {
		return (
			<Chip
				{...rest}
				ref={ref}
				label={label}
				size={size}
				sx={{
					p: '0',
					ml: 1,
					fontSize: '.7rem',
					height: '16px',
					bgcolor: bgcolor,
					color: color,
					fontWeight: bold ? '550' : '400',
					cursor: onClick ? 'pointer' : 'default',
					'&:hover': {
						bgcolor: onClick ? bgcolor + '95' : bgcolor,
					},
				}}
				onClick={(e) => {
					if (onClick) {
						e.stopPropagation();
						onClick();
					}
				}}
			/>
		);
	},
);

EasChip.displayName = 'EasChip';
